import * as React from 'react';
import { useState, useEffect } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Col, Alert, Label, Input} from 'reactstrap';
import Page from '../Page';
import { useAppSelector, useAppDispatch } from '../../hooks/index';
import { Entity, getSelectedEntity } from '../../redux/EntitySlice';
import { Afr, FactTable, factValue, getSelectedAfr, getTable, generateLocalStateFromEventProperties, updateVersionStateValue} from '../../redux/AfrSlice';
import { setIsDirty, isAdmin, getSelector, getTableFacts } from '../../redux/MiscSlice';
import { resetConceptState } from "../../redux/ConceptSlice";
import AffiliatedEntitiesCoreDetail from '../AfrCore/AffiliatedEntitiesCoreDetail';
import AffiliatedEntitiesAuditDetail from '../AfrCore/AffiliatedEntitiesAuditDetail';
import { useLocation } from 'react-router-dom';
import enums from '../../utils/enums';
import AffiliatedEntityDetail from './AffiliatedEntityDetail';
import utilityHelper from '../../utils/utilityHelper';


const AffiliatedEntitiesCore = (props: { userRole: string }) => {

    const dispatch = useAppDispatch();
    const parameters = useLocation();

    const currentAfr: Afr | null = useAppSelector(getSelectedAfr);
    const tableId: FactTable | null = getTable(currentAfr, enums.tableName.affiliatedEntity);
    const afrYear = currentAfr ? currentAfr.year : 0;
    const entity: Entity | null = useAppSelector(getSelectedEntity);
    var ename = "none";
    var ecode = "";
    if (entity) {
        ename = entity.name;
        ecode = entity.code;
    }
    const isAdminUser: boolean = useAppSelector(isAdmin);

    /* Tabs logic */
    const [activeTab, setActiveTab] = useState("1");
    const [hasFacts, setHasFacts] = useState(true);
    const [afrId, setAfrId] = useState(ename + afrYear);
    const [state, setState] = useState(generateLocalStateFromEventProperties(currentAfr, ["reviewState_componentUnitsReviewed"]));

    const toggle = (tab: string) => {
        if (activeTab !== tab) setActiveTab(tab);
    }

    const activeClass = (tab: string) => {
        return (tab === activeTab) ? "active" : "";
    }

    const handleChangeCheckbox = function (event: any) {

        var checkValues = JSON.parse(JSON.stringify(state));
        var key: string = event.target.name;
        var value: boolean = event.target.checked
        checkValues[key] = value;

        setState(checkValues);

        // here call to dispatcher sending:
        var eventFirstlevel = key.split("_")[0]
        var eventSecondlevel = key.split("_")[1]

        // Update global flag for this event in redux
        dispatch(updateVersionStateValue({ propGroup: eventFirstlevel, propName: eventSecondlevel, boolValue: value, value: null }));

        // set the dirty flag to TRUE
        dispatch(setIsDirty({ IsDirty: true, Page: "" }))

    }

    useEffect(() => {
        // get state from redux
        var newLocalState = generateLocalStateFromEventProperties(currentAfr, ["reviewState_componentUnitsReviewed"])

        // create a local state from redux
        setState(newLocalState)

    }, [currentAfr])

    useEffect(() => {

        dispatch(resetConceptState({}));

        // save all the pending changes into AFRSlice
        utilityHelper.saveDeferredChanges(dispatch);

    }, [activeTab]);

    useEffect(() => {
        if (parameters.state && parameters.state.tabId && parameters.state.tabId.length > 0) {
            toggle(parameters.state.tabId);
        }

    }, [parameters.state]);

    const affiliateMasterTable = React.useMemo(() => {
        return (
            <AffiliatedEntitiesCoreDetail />
        )
    }, [activeTab, afrId]);


    return (
        <React.Fragment>
            <Page>
                <h2>Affiliated Entities for {utilityHelper.getEntityName(entity, currentAfr)} ({utilityHelper.getEntityCode(entity, currentAfr)}), {afrYear}</h2>
                {isAdminUser &&
                    (<div className="box-events pl-2 pr-3 py-3 my-2">
                        <div>
                            <Label className="ml-4" check>
                                <Input type="checkbox"
                                    name="reviewState_componentUnitsReviewed"
                                    onChange={handleChangeCheckbox}
                                checked={state["reviewState_componentUnitsReviewed"]}
                                    disabled={!utilityHelper.checkStatusList(currentAfr, enums.certifiedRecertified)}
                                /><b>Reviewed</b>
                            </Label>
                        </div>
                    </div>)}

                <Row>
                    <Col>
                        <div>
                            <Nav tabs>
                                <NavItem>
                                    <NavLink
                                        className={activeClass('1')}
                                        onClick={() => { toggle('1'); }}
                                    >
                                        Instructions
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={activeClass('2')}
                                        onClick={() => { toggle('2'); }}
                                    >
                                        Affiliated Entities
                                    </NavLink>
                                </NavItem>
                            </Nav>
                            <TabContent activeTab={activeTab}>
                                <TabPane tabId="1">
                                    <Row>
                                        <Col>
                                            <h5>
                                                <p>To input Component Unit information, please follow the prompt for each affiliated entity listed in the Affiliated Entities tab and identify whether or not the entity is a component unit. If the entity is a component unit, please select the reporting type for the selected Fiscal Year of this AFR.</p>
                                                <p>You will be prompted to enter total assets, liabilities, revenues, expenditures, and long-term debt amounts only for those component units who are blended or discretely reported. Component Units with zero revenues and expenditures are still required to enter the total assets, liabilities, and long-term debt.</p>
                                                <p>To set up a new Component Unit, contact the Department of Financial Services’ Bureau of Financial Reporting, Local Government Section at (850) 413-5571 or email your request to localgov@myfloridacfo.com</p>
                                                <p>NOTE: The Reporting Type for Community Redevelopment Agencies (CRAs) should be based on the information from the Reporting Entity(ies) section in the Notes of the primary government. The Reporting Type for the CRA should not be based on if the CRA had an independent audit per 163.387, F.S.</p>
                                            </h5>
                                        </Col>
                                    </Row>
                                </TabPane>
                                <TabPane tabId="2">
                                    
                                    {tableId && tableId.rows && tableId.rows.length > 0 ?
                                        (<>
                                         <Row>
                                             <Col>
                                                {affiliateMasterTable}
                                             </Col>
                                         </Row>
                                         <Row>
                                            <Col>
                                                <AffiliatedEntityDetail />  
                                            </Col>
                                         </Row>
                                         </>)
                                     :
                                        (<>
                                          <Row>
                                             <Col>
                                                <Alert color="danger">
                                                        <p>There are no Affiliated Entities</p>
                                                </Alert>
                                             </Col>
                                          </Row>
                                         </>   )
                                      }
                                    
                                </TabPane>
                            </TabContent>
                        </div>
                    </Col>
                </Row>
            </Page>
        </React.Fragment>
    );
}

export default AffiliatedEntitiesCore;